import type { User } from './user-types'
import { api } from '@/api/api'

export const userService = {
  getById: async (id: number) => {
    const { data } = await api.get<User>(`/users/${id}/`)
    return data
  }
}
